// src/components/TenderSelectionPage.js
import React from 'react';
import { Link } from 'react-router-dom';
import Layout from './components/Layout'; // Make sure Layout is correctly imported
import './TenderSelectionPage.css'; // Import the new CSS file

function TenderSelectionPage() {
  return (
    <Layout>
      <div className="tender-selection-container">
        <h1>Welcome to Tender Managers</h1>
        <p>Select a workspace below.</p>

        <div className="account-quick-link">
          <Link to="/subscription" className="selection-btn account-btn">
            Upgrade Plan / Purchase Add-ons
          </Link>
        </div>

        <section className="selection-group group-tendermaker">
          <h2>TenderMaker Workspace</h2>
          <div className="group-grid">
            <Link to="/tendermaker" className="selection-btn">
              TenderMaker / Bid Studio
            </Link>
          </div>
        </section>

        <section className="selection-group group-live-archive">
          <h2>Live and Archive</h2>
          <div className="group-grid">
            <Link to="/gem-v2/bids" className="selection-btn">
              GeM Bids - Live and Archive
            </Link>
            <Link to="/cppp-tenders" className="selection-btn">
              Non-GeM Tenders (CPPP etc.) - Live and Archive
            </Link>
          </div>
        </section>

        <section className="selection-group group-results">
          <h2>Results</h2>
          <div className="group-grid">
            <Link to="/gem-v2-results" className="selection-btn">
              GeM Bids Results
            </Link>
            <Link to="/GeM-contracts-dashboard" className="selection-btn">
              GeM Contracts Dashboard
            </Link>
            <Link to="/cppp-v2-results" className="selection-btn">
              Non GeM Tender Results (CPPP etc)
            </Link>
            <Link to="/cpwd-tender-results" className="selection-btn">
              CPWD Tender Results
            </Link>
          </div>
        </section>

        <section className="selection-group group-reports">
          <h2>Reports</h2>
          <div className="group-grid">
            <Link to="/product-reports" className="selection-btn">
              Download Product Reports
            </Link>
            <Link to="/state-reports" className="selection-btn">
              Download State Reports
            </Link>
            <Link to="/ministry-reports" className="selection-btn">
              Download Ministry Reports
            </Link>
            <Link to="/service-reports" className="selection-btn">
              Download Service Reports
            </Link>
          </div>
        </section>
      </div>
    </Layout>
  );
}

export default TenderSelectionPage;
